import {
    aggregate,
    executeAggregation,
    collectionQueryBuilder,
    enableAggregatePreview,
    enableFlexibleQueryPreview,
    getCollectionData,
    storeCollectionQueryBuilder,
} from './collectionsApi';

const api = {
    query: getCollectionData,
    data: collectionQueryBuilder,
    storeData: storeCollectionQueryBuilder,
    aggregate: aggregate,
    executeAggregation: executeAggregation,
    enableFlexibleQueryPreview: enableFlexibleQueryPreview,
    enableAggregatePreview: enableAggregatePreview,
};

export default api;
